import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazyTemplateList = lazyWithRetry(() => import('./templateList'));
